import { useTranslation } from "next-i18next";
import React, { ReactElement } from "react";
import styles from "./style.module.scss";
import { Button, Text } from "@kunduz/ui-atoms";

const BlogPagination = (props: Props): ReactElement => {
  const { t } = useTranslation("kunduzcom_blog");

  function getPrevUrl() {
    if (props.pageInfo.startCursor) {
      return `?before=${props.pageInfo.startCursor}`;
    }
    return "#";
  }

  function getNextUrl() {
    if (props.pageInfo.endCursor) {
      return `?after=${props.pageInfo.endCursor}`;
    }
    return "#";
  }

  return (
    <div className={styles.paginationWrapper}>
      {props.pageInfo.hasPreviousPage && (
        <Button
          variant="primary"
          color="blue"
          size="lg"
          as="a"
          href={getPrevUrl()}
          rel="noindex"
        >
          <Text variant="textmd" weight="medium">
            {t("blog_pagination_prev_label")}
          </Text>
        </Button>
      )}
      {props.pageInfo.hasNextPage && (
        <Button
          variant="primary"
          color="blue"
          size="lg"
          as="a"
          href={getNextUrl()}
          rel="noindex"
        >
          <Text variant="textmd" weight="medium">
            {t("blog_pagination_next_label")}
          </Text>
        </Button>
      )}
    </div>
  );
};

interface Props {
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string;
    endCursor: string;
  };
}

export default BlogPagination;
